<template>
  <div class="detail" id="nowPrintDetail">
    <div class="tableWrap">
      <div class="tableRow" v-for="(item, index) in detailList" :key="index">
        <div class="tableLeft">{{ item.name }}</div>
        <div class="tableRight" v-if="typeof item.value == 'string'">
          {{ item.value }}
        </div>
        <div class="tableRight" v-else>
          <div class="tableItem" v-for="(it, i) in item.value" :key="i">
            {{ mapType[it.level] }} ：{{ it.ptype }} / {{ it.ctype }}
          </div>
        </div>
      </div>
      <div class="tableRow">
        <div class="tableLeft">告知单</div>
        <div class="tableRight">
          <a :href="detailDownload" download v-if="detailDownload">下载</a>
        </div>
      </div>
    </div>
    <div class="imgList">
      <div>图片：</div>
      <div class="imgWrap">
        <el-image
          :src="img"
          :preview-src-list="imgList"
          class="eachImg"
          v-for="(img, index) in imgList"
          :key="index"
          @load="load"
        ></el-image>
      </div>
      <div v-if="videoUrl" class="video">
        <div>视频：</div>
        <video
          v-for="(item, index) in urlList"
          :key="index"
          class="videos"
          controls="controls"
          :src="item"
        ></video>
      </div>
    </div>

    <timeline v-if="timelineList.length" :timelineList="timelineList" />
    <div v-else class="noData">暂无流转详情</div>
  </div>
</template>

<script>
import Timeline from "@/components/Events/TimeLine";

export default {
  components: {
    Timeline,
  },
  data() {
    return {
      mapType: {
        1: "一般类问题",
        2: "严重类问题",
        3: "特别严重问题",
      },
      imgNumber: 0,
    };
  },
  props: {
    videoUrl: {
      type: String,
      default: "",
    },
    detailList: {
      type: Array,
      default: () => [],
    },
    detailDownload: {
      type: String,
      default: "",
    },
    imgList: {
      type: Array,
      default: () => [],
    },
    timelineList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    urlList() {
      return this.videoUrl.split("|");
    },
  },
  methods: {
    load() {
      this.imgNumber++;
      if (this.imgNumber === this.imgList.length) {
        this.imgNumber = 0;
        this.$emit("load");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.detail {
  height: auto;
  overflow: scroll;
  padding: 30px 20px;
  border-bottom: 1px solid #e2e5ec;
}
.noData {
  text-align: center;
}
.tableWrap {
  margin-top: 26px;
  border-top: 1px solid #e2e5ec;
  .tableRow {
    font-size: 15px;
    display: flex;

    .tableRight {
      padding: 16px 0;
      // width: 296px;
      width: 100%;
      color: #3b445a;
      a {
        cursor: pointer;
      }
    }
    .tableLeft,
    .tableRight {
      min-height: 56px;
      padding-left: 12px;
      box-sizing: border-box;
      border: 1px solid #e2e5ec;
    }

    .tableLeft {
      width: 160px;
      color: #707b86;
      border-right: none;
      line-height: 56px;
      &:first-child {
        border-top: none;
      }
    }

    .tableRight {
      border-top: none;
    }
  }
}
.imgList {
  color: #707b86;
  font-size: 15px;
  padding: 20px;
  border-bottom: 1px solid #e2e5ec;
  margin-bottom: 23px;
  .imgWrap {
    margin-top: 20px;
    display: flex;
    // justify-content: space-between;
    flex-direction: flex-start;
    flex-wrap: wrap;
    box-sizing: border-box;
    padding: 0 20px;
    .eachImg,
    .eachImg img {
      border-radius: 5px;
      width: 120px;
      height: 72px;
      margin-right: 10px;
      margin-bottom: 12px;
    }
  }
  .video {
    margin-top: 10px;
    div {
      margin-bottom: 10px;
    }
  }
  .videos {
    width: 100%;
    height: 150px;
    margin-bottom: 20px;
  }
}
</style>